// Wächst mit dem Inhalt bis `maxRows` Zeilen, danach scrollt das Feld in sich (Textarea, Composer).
import { useLayoutEffect, type RefObject } from 'react';

export function autoGrow(el: HTMLTextAreaElement, maxRows: number, minHeight = 0) {
  const style = getComputedStyle(el);
  const line = parseFloat(style.lineHeight) || 22;
  const padding = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
  const max = line * maxRows + padding;
  el.style.height = 'auto';
  // Leeres Feld: eine Zeile – ein langer Platzhalter soll die Pill nicht aufblähen.
  const content = el.value === '' ? line + padding : el.scrollHeight;
  const next = Math.max(minHeight, Math.min(content, max));
  el.style.height = `${next}px`;
  el.style.overflowY = el.scrollHeight > max ? 'auto' : 'hidden';
}

/** Passt die Höhe nach jeder Wertänderung an (kontrolliert) – unkontrolliert ruft man autoGrow im onInput. */
export function useAutoGrow(
  ref: RefObject<HTMLTextAreaElement | null>,
  value: unknown,
  maxRows: number,
  minHeight = 0,
) {
  useLayoutEffect(() => {
    if (ref.current) autoGrow(ref.current, maxRows, minHeight);
  }, [ref, value, maxRows, minHeight]);
}
